import React, { useState, useEffect, useRef } from 'react'
import Filter from '../../components/Filter'
import {
	Row,
	Col,
	Image,
	InputGroup,
	FormControl,
	Button,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faFileDownload,
	faChevronRight,
	faChevronLeft
} from '@fortawesome/free-solid-svg-icons'
import styles from './Employers.module.scss'
import EButton from '../../components/bootstrap-extended/EButton'
import 'react-day-picker/lib/style.css'
import ReactPaginate from 'react-paginate'
import { useLocation, useNavigate } from 'react-router-dom'
import { CSVLink } from 'react-csv'
import axios from 'axios'

interface DataProps {
	id: number
	name: string
	avatar: string,
	number_of_jobs: number,
	application: {
		total: number,
		pending: number,
		shortlisted: number,
		successful: number,
		unsuccessful: number
	}
}

function useQuery() {
	const { search } = useLocation()
	return React.useMemo(() => new URLSearchParams(search), [search])
}

const Employers = () => {
	const csvLink = useRef<any | null>(null)
	const navigate = useNavigate()
	const query = useQuery()
	const [employers, setEmployers] = useState<Array<DataProps> | null>([])
	const [pageNo, setPageNo] = useState('')
	const [toPage, setToPage] = useState<number>(0)
	const [isLoading, setIsLoading] = useState(true)

	const [dataExport, setDataExport] = useState<any[]>([])
	const [dataAggregate, setDataAggregate] = useState(0)

	const [keyword, setKeyword] = useState<string>('')
	const [filterPage, setFilterPage] = useState('')

	// pagination
	const [pageCount, setPageCount] = useState(0)
	const itemsPerPage = 10

	const exportHeader = [
		{ label: 'Company', key: 'name' },
		{ label: 'Jobs', key: 'number_of_jobs' },
		{ label: 'Applications', key: 'application.total' },
		{ label: 'Pending', key: 'application.pending' },
		{ label: 'Shortlisted', key: 'application.shortlisted' },
		{ label: 'Successfull', key: 'application.successful' },
		{ label: 'Unsuccessful', key: 'application.unsuccessful' },
	]

	useEffect(() => {
		const toNum = () => {
			if (pageNo === '') {
				setToPage(0)
			} else {
				const temp = parseInt(pageNo)
				setToPage(temp - 1)
			}
		}
		toNum()
	}, [pageNo])

	const page = query.get('page')
	const keywordSeach = query.get('keyword')

	const filters = {
		page: (page !== null && parseInt(page)) ? page : 1,
		keyword: (keywordSeach !== null ? keywordSeach as string : '').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\\{\\}\\[\]\\\\/]/gi, ''),
	}
	const handlePageClick = (event: { selected: number }) => {
		window.location.href = getPaginationLink((event.selected + 1).toString())
	}

	const getPaginationLink = (page: string): string => {
		const keyword: string = filters.keyword as string
		return `/employers?page=${page}&keyword=${encodeURIComponent(keyword)}`
	}

	const handleKeyDown = (e: any): void => {
		if (e.keyCode === 13) {
			redirectNewUrl()
		}
	}

	const redirectNewUrl = (): void => {
		const keywordSearch: string = keyword.replace(/[`~!@#$%^&*()_|+\-=?;:'".<>\\{\\}\\[\]\\\\/]/gi, '')
		window.location.href = `/employers?page=1&keyword=${encodeURIComponent(keywordSearch)}`
	}

	useEffect(() => {
		const getEmployers = async () => {
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_GET_COMPANY as string + `?page=${filters.page}&keyword=${filters.keyword}`)
				setEmployers(res.data.companies)
				setIsLoading(false)
				setPageCount(Math.ceil(res.data.companyAggregate / itemsPerPage))
				setKeyword(filters.keyword)
				setPageNo(filters.page.toString())
				setDataAggregate(res.data.companyAggregate)
			} catch (err) {
				console.log(err)
			}
		}
		getEmployers()
	}, [])

	useEffect(() => {
		if (dataExport && csvLink && csvLink.current && csvLink.current.link) {
			setTimeout(() => {
				csvLink.current.link.click()
				setDataExport([])
			})
		}
	}, [dataExport])

	const getAllEmployers = async () => {
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_COMPANY as string + `?pageSize=${dataAggregate}&keyword=${filters.keyword}`)
			setDataExport(res.data.companies)
		} catch (err) {
			console.log(err)
		}
	}

	const numbersOnly = (val: string) => {
		const numsCheck = new RegExp('^[0-9]{1,6}$')//6 digits only
		if (numsCheck.test(val) || val === '') {
			setFilterPage(val)
		}
		if (parseInt(val) > pageCount) {
			setFilterPage(pageCount.toString())
		}
	}

	const submitPageNumber = () => {
		window.location.href = `/employers?page=${filterPage}&keyword=${encodeURIComponent(filters.keyword)}`
	}

	return (
		<div>
			<Row>
				<Col>
					<Filter />
				</Col>
			</Row>
			<Row className={styles.searchCompRow}>
				<Col style={{ display: 'flex', flexFlow: 'row wrap' }} className='gap-3'>
					<Col lg={4} xs={12}>
						<div style={{ display: 'flex' }}>
							<InputGroup className={styles.searchInput}>
								<InputGroup.Text id="basic-addon1">
									{' '}<Image src='/img/search.png' alt='search' width='15' height='15' />
								</InputGroup.Text>
								<FormControl
									name='keyword'
									placeholder="Search"
									value={keyword}
									onChange={e => {
										setKeyword(e.target.value)
									}}
									onKeyDown={handleKeyDown}
								/>
							</InputGroup>
						</div>
					</Col>
				</Col>
				<Col lg={2} md={2}>
					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<div onClick={getAllEmployers}>
							<EButton
								buttonText='Export'
								icon={<FontAwesomeIcon icon={faFileDownload} />} isSubmitting={false} className={styles.cusBtn}
							/>
						</div>
						{dataExport.length > 0 ?
							<CSVLink
								data={dataExport}
								headers={exportHeader}
								filename={'Employers.csv'}
								ref={csvLink}
							/>
							: undefined
						}
					</div>
				</Col>
			</Row>
			{/* table */}
			{/* header */}
			<div style={{ overflowX: 'auto' }}>
				<table style={{ width: '100%' }}>
					<div className={styles.tableHeader}>
						<Row className={styles.mobileViewSlideTable}>
							{['Company', 'Jobs', 'Applications', 'Pending', 'Shortlisted', 'Successful', 'Unsuccessful'].map((val, index) => (
								<Col key={index} xs={index === 0 && 2} sm={index == 0 && 3} className={index !== 0 ? 'text-center' : ''}>
									<h6 className={index === 6 ? 'pe-5 pe-sm-3' : ''}>{val}</h6>
								</Col>
							))}
						</Row>
					</div>
					{/* items */}
					<div>
						{isLoading ? (
							<div className='text-center mt-3'>
								<p>Loading</p>
							</div>
						) : (
							employers && employers.map((company, index) => {
								return (
									<div key={index} className={styles.tableBody} onClick={() => navigate(`/employers/${company.id}`)}>
										<Row className={styles.mobileViewSlideTable}>
											<Col xs={2} sm={3} className='d-flex align-items-center ps-4'>
												{
													company.avatar ? (
														<Image
															roundedCircle
															src={company.avatar}
															alt='search'
															width='60'
															height='60'
															style={{ marginRight: '10px', objectFit: 'contain', padding: '10px' }}
														/>
													) : (
														<div style={{ marginRight: '10px', width:'60px' }} className='d-flex justify-content-center align-items-center text-center'>
															<p style={{ fontSize: '5px' }}>{company.name}</p>
														</div>
													)
												}
												<p style={{ textAlign: 'left', overflowWrap: 'break-word', wordBreak: 'break-all' }} className='px-0'>{company.name}</p>
											</Col>
											<Col className={styles.flex}><p className={styles.data}>{company.number_of_jobs}</p></Col>
											<Col className={styles.flex}><p className={styles.data}>{company.application.total}</p></Col>
											<Col className={styles.flex}><p className={styles.data}>{company.application.pending}</p></Col>
											<Col className={styles.flex}><p className={styles.data}>{company.application.shortlisted}</p></Col>
											<Col className={styles.flex}><p className={styles.data}>{company.application.successful}</p></Col>
											<Col className={styles.flex}><p className={styles.data}>{company.application.unsuccessful}</p></Col>
										</Row>
									</div>
								)
							})
						)}
					</div>
				</table>
			</div>

			<Row style={{ marginTop: '20px' }}>
				<Col />
				<Col>
					<ReactPaginate
						containerClassName={styles.pagination}
						previousClassName="page-item"
						nextLinkClassName="page-link"
						// activeClassName="active"
						activeLinkClassName={styles.paginationActive}
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						breakLinkClassName="page-link"
						breakClassName="page-item"
						previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
						pageCount={pageCount}
						onPageChange={handlePageClick}
						nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
						pageRangeDisplayed={3}
						marginPagesDisplayed={3}
						breakLabel="..."
						forcePage={toPage}
					/>
				</Col>
				<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<span style={{ fontSize: '14px', color: '#5B7493', paddingTop: '5px' }}>Go to page</span>
					<FormControl
						style={{ width: '15%', display: 'inline-block', margin: '0 10px', height: '35px' }}
						onChange={e => {
							numbersOnly(e.target.value)
						}}
						value={filterPage}
					/>
					<Button onClick={submitPageNumber} variant='primary' className={styles.cusBtn}>
						Go
					</Button>
				</Col>
			</Row>
		</div>
	)
}

export default Employers